/// <reference path="../_references.ts"/>

module App.Administrative.VendorInventory {
    export class VendorInventoryService {
        static $inject = ['$http', 'Constants'];
        constructor(
            private $http: ng.IHttpService,
            public Constants: IConstants
        ) {

        }

        public getAll(params: any = {}): ng.IHttpPromise<VendorInventory[]> {
            return this.$http.get(`${this.Constants.apiUrl}vendorinventory`, {
                params: params,
            });
        }

        public getAllReplenishments(params: any = {}): ng.IHttpPromise<VendorInventoryReplenishment[]> {
            return this.$http.get(`${this.Constants.apiUrl}vendorinventoryreplenishment`, {
                params: params,
            });
        }

        public getTagGroups(params: any = {}): ng.IHttpPromise<TagGroup[]> {
            return this.$http.get(`${this.Constants.apiUrl}vendorinventorytaggroup`, {
                params: params,
            });
        }

        public createReplenishments(data: any, params: any = {}): ng.IHttpPromise<TagGroup[]> {
            return this.$http.post(`${this.Constants.apiUrl}vendorinventoryreplenishment/bulk`, data, {
                params: params,
            });
        }

        public setFavourite(id: number, favourite: boolean, params: any = {}): ng.IHttpPromise<VendorInventory> {
        	return this.$http.put(`${this.Constants.apiUrl}vendorinventory/${id}`, { favourite }, {
        		params: params,
        	});
        }
    }
}